
import { useState } from 'react';

interface Transformation {
  id: number;
  name: string;
  treatment: string;
  duration: string;
  before: string;
  after: string;
  description: string;
}

const transformations: Transformation[] = [
  {
    id: 1,
    name: 'Carla M.',
    treatment: 'Emagrecimento Personalizado',
    duration: '4 meses',
    before: 'https://public.readdy.ai/ai/img_res/02189d942c5a82858560b7bd770eb029.jpg',
    after: 'https://readdy.ai/api/search-image?query=after%20weight%20loss%20transformation%20photo%20fit%20healthy%20woman%20standing%20confident%20pose%20plain%20warm%20beige%20studio%20background%20soft%20lighting%20professional%20clinical%20photography%20simple%20clean%20aesthetic%20no%20text%20no%20graphics&width=400&height=520&seq=ba-after-001&orientation=portrait',
    description: 'Perdeu 18kg com programa personalizado de emagrecimento e acompanhamento nutricional completo.'
  },
  {
    id: 2,
    name: 'Fernanda S.',
    treatment: 'Modelagem Corporal',
    duration: '3 meses',
    before: 'https://readdy.ai/api/search-image?query=before%20body%20contouring%20treatment%20photo%20woman%20side%20view%20neutral%20pose%20plain%20warm%20beige%20studio%20background%20soft%20natural%20lighting%20professional%20clinical%20aesthetic%20photography%20simple%20clean%20no%20text&width=400&height=520&seq=ba-before-002&orientation=portrait',
    after: 'https://readdy.ai/api/search-image?query=after%20body%20contouring%20treatment%20photo%20toned%20woman%20side%20view%20confident%20pose%20plain%20warm%20beige%20studio%20background%20soft%20natural%20lighting%20professional%20clinical%20aesthetic%20photography%20simple%20clean%20no%20text&width=400&height=520&seq=ba-after-002&orientation=portrait',
    description: 'Redução de 12cm na cintura com sessões de modelagem corporal e radiofrequência.'
  },
  {
    id: 3,
    name: 'Juliana R.',
    treatment: 'Tratamento Facial',
    duration: '2 meses',
    before: 'https://readdy.ai/api/search-image?query=before%20facial%20rejuvenation%20treatment%20close%20up%20woman%20face%20with%20aging%20signs%20plain%20warm%20beige%20background%20soft%20studio%20lighting%20professional%20dermatology%20clinical%20photography%20clean%20aesthetic%20no%20text&width=400&height=520&seq=ba-before-003&orientation=portrait',
    after: 'https://readdy.ai/api/search-image?query=after%20facial%20rejuvenation%20treatment%20close%20up%20woman%20face%20glowing%20radiant%20youthful%20skin%20plain%20warm%20beige%20background%20soft%20studio%20lighting%20professional%20dermatology%20clinical%20photography%20clean%20aesthetic%20no%20text&width=400&height=520&seq=ba-after-003&orientation=portrait',
    description: 'Rejuvenescimento facial completo com harmonização e tratamentos anti-idade avançados.'
  },
  {
    id: 4,
    name: 'Patrícia L.',
    treatment: 'Drenagem Linfática',
    duration: '6 semanas',
    before: 'https://readdy.ai/api/search-image?query=before%20lymphatic%20drainage%20treatment%20photo%20woman%20with%20body%20swelling%20neutral%20pose%20plain%20warm%20beige%20studio%20background%20soft%20lighting%20professional%20wellness%20clinical%20photography%20simple%20clean%20aesthetic%20no%20text&width=400&height=520&seq=ba-before-004&orientation=portrait',
    after: 'https://readdy.ai/api/search-image?query=after%20lymphatic%20drainage%20treatment%20photo%20woman%20with%20slim%20defined%20body%20confident%20pose%20plain%20warm%20beige%20studio%20background%20soft%20lighting%20professional%20wellness%20clinical%20photography%20simple%20clean%20aesthetic%20no%20text&width=400&height=520&seq=ba-after-004&orientation=portrait',
    description: 'Eliminação de retenção de líquidos e redução visível de inchaço com drenagem especializada.'
  },
  {
    id: 5,
    name: 'Amanda C.',
    treatment: 'Emagrecimento + Modelagem',
    duration: '5 meses',
    before: 'https://readdy.ai/api/search-image?query=before%20combined%20weight%20loss%20body%20sculpting%20treatment%20photo%20woman%20front%20view%20neutral%20pose%20plain%20warm%20beige%20studio%20background%20soft%20lighting%20professional%20clinical%20photography%20simple%20clean%20aesthetic%20no%20text&width=400&height=520&seq=ba-before-005&orientation=portrait',
    after: 'https://readdy.ai/api/search-image?query=after%20combined%20weight%20loss%20body%20sculpting%20treatment%20photo%20fit%20toned%20woman%20front%20view%20confident%20pose%20plain%20warm%20beige%20studio%20background%20soft%20lighting%20professional%20clinical%20photography%20simple%20clean%20aesthetic%20no%20text&width=400&height=520&seq=ba-after-005&orientation=portrait',
    description: 'Transformação completa com perda de 22kg e modelagem corporal para definição muscular.'
  },
  {
    id: 6,
    name: 'Beatriz F.',
    treatment: 'Tratamento Capilar',
    duration: '3 meses',
    before: 'https://readdy.ai/api/search-image?query=before%20hair%20treatment%20photo%20woman%20with%20thin%20damaged%20hair%20plain%20warm%20beige%20studio%20background%20soft%20lighting%20professional%20trichology%20clinical%20photography%20simple%20clean%20aesthetic%20no%20text%20no%20graphics&width=400&height=520&seq=ba-before-006&orientation=portrait',
    after: 'https://readdy.ai/api/search-image?query=after%20hair%20treatment%20photo%20woman%20with%20thick%20shiny%20healthy%20voluminous%20hair%20plain%20warm%20beige%20studio%20background%20soft%20lighting%20professional%20trichology%20clinical%20photography%20simple%20clean%20aesthetic%20no%20text%20no%20graphics&width=400&height=520&seq=ba-after-006&orientation=portrait',
    description: 'Recuperação capilar completa com tratamentos de reconstrução e fortalecimento dos fios.'
  }
];

const categories = ['Todos', 'Emagrecimento', 'Modelagem', 'Facial', 'Drenagem', 'Capilar'];

export default function BeforeAfter() {
  const [activeFilter, setActiveFilter] = useState('Todos');
  const [selectedCard, setSelectedCard] = useState<number | null>(null);
  const [sliderPositions, setSliderPositions] = useState<Record<number, number>>({});

  const filteredTransformations = activeFilter === 'Todos'
    ? transformations
    : transformations.filter(t =>
        t.treatment.toLowerCase().includes(activeFilter.toLowerCase())
      );

  const handleSliderChange = (id: number, value: number) => {
    setSliderPositions(prev => ({ ...prev, [id]: value }));
  };

  const getSliderPosition = (id: number) => sliderPositions[id] ?? 50;

  return (
    <section id="antes-depois" className="py-32 bg-gradient-to-b from-white via-[#F8F6F4] to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-6 py-2 bg-[#915726]/10 rounded-full mb-6">
            <span className="text-[#915726] text-sm font-semibold tracking-wider uppercase">Resultados Reais</span>
          </div>
          <h2
            className="text-5xl md:text-6xl font-bold text-[#676028] mb-6"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Antes &amp; Depois
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Conheça as transformações reais de nossas clientes e inspire-se para iniciar sua própria jornada de renovação
          </p>
        </div>

        {/* Filtros */}
        <div className="flex flex-wrap justify-center gap-3 mb-16">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveFilter(cat)}
              className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeFilter === cat
                  ? 'bg-[#915726] text-white shadow-lg shadow-[#915726]/30'
                  : 'bg-white text-gray-600 hover:bg-[#915726]/10 hover:text-[#915726] border border-gray-200'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Galeria */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredTransformations.map((item) => (
            <div
              key={item.id}
              className="group bg-white rounded-3xl overflow-hidden hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-gray-100"
            >
              {/* Slider de Comparação */}
              <div
                className="relative w-full h-80 overflow-hidden cursor-ew-resize select-none"
                onMouseMove={(e) => {
                  const rect = e.currentTarget.getBoundingClientRect();
                  const x = ((e.clientX - rect.left) / rect.width) * 100;
                  handleSliderChange(item.id, Math.max(5, Math.min(95, x)));
                }}
                onTouchMove={(e) => {
                  const rect = e.currentTarget.getBoundingClientRect();
                  const touch = e.touches[0];
                  const x = ((touch.clientX - rect.left) / rect.width) * 100;
                  handleSliderChange(item.id, Math.max(5, Math.min(95, x)));
                }}
              >
                {/* Imagem Depois (fundo) */}
                <img
                  src={item.after}
                  alt={`Depois - ${item.name}`}
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />

                {/* Imagem Antes (clip) */}
                <div
                  className="absolute inset-0 overflow-hidden"
                  style={{ clipPath: `inset(0 ${100 - getSliderPosition(item.id)}% 0 0)` }}
                >
                  <img
                    src={item.before}
                    alt={`Antes - ${item.name}`}
                    className="absolute inset-0 w-full h-full object-cover object-top"
                  />
                </div>

                {/* Linha divisória */}
                <div
                  className="absolute top-0 bottom-0 w-0.5 bg-white shadow-lg z-10"
                  style={{ left: `${getSliderPosition(item.id)}%` }}
                >
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-xl flex items-center justify-center">
                    <i className="ri-arrow-left-right-line text-[#915726] text-lg"></i>
                  </div>
                </div>

                {/* Labels */}
                <div className="absolute top-4 left-4 px-3 py-1 bg-black/50 backdrop-blur-sm rounded-full z-10">
                  <span className="text-white text-xs font-semibold">Antes</span>
                </div>
                <div className="absolute top-4 right-4 px-3 py-1 bg-[#915726]/80 backdrop-blur-sm rounded-full z-10">
                  <span className="text-white text-xs font-semibold">Depois</span>
                </div>
              </div>

              {/* Info */}
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <h3
                    className="text-xl font-bold text-[#676028]"
                    style={{ fontFamily: "'Cormorant Garamond', serif" }}
                  >
                    {item.name}
                  </h3>
                  <span className="px-3 py-1 bg-[#915726]/10 text-[#915726] text-xs font-semibold rounded-full whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
                <div className="flex items-center gap-2 mb-3">
                  <i className="ri-stethoscope-line text-[#915726] text-sm w-4 h-4 flex items-center justify-center"></i>
                  <span className="text-sm font-medium text-[#915726]">{item.treatment}</span>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Modal de detalhe */}
        {selectedCard !== null && (
          <div
            className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-6"
            onClick={() => setSelectedCard(null)}
          >
            <div
              className="bg-white rounded-3xl max-w-3xl w-full overflow-hidden shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              {(() => {
                const item = transformations.find(t => t.id === selectedCard);
                if (!item) return null;
                return (
                  <div>
                    <div className="grid grid-cols-2 gap-0">
                      <div className="relative w-full h-96">
                        <img src={item.before} alt="Antes" className="w-full h-full object-cover object-top" />
                        <div className="absolute bottom-4 left-4 px-4 py-1.5 bg-black/50 backdrop-blur-sm rounded-full">
                          <span className="text-white text-sm font-semibold">Antes</span>
                        </div>
                      </div>
                      <div className="relative w-full h-96">
                        <img src={item.after} alt="Depois" className="w-full h-full object-cover object-top" />
                        <div className="absolute bottom-4 right-4 px-4 py-1.5 bg-[#915726]/80 backdrop-blur-sm rounded-full">
                          <span className="text-white text-sm font-semibold">Depois</span>
                        </div>
                      </div>
                    </div>
                    <div className="p-8">
                      <div className="flex items-center justify-between mb-4">
                        <h3
                          className="text-3xl font-bold text-[#676028]"
                          style={{ fontFamily: "'Cormorant Garamond', serif" }}
                        >
                          {item.name}
                        </h3>
                        <button
                          onClick={() => setSelectedCard(null)}
                          className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors cursor-pointer"
                        >
                          <i className="ri-close-line text-xl text-gray-600"></i>
                        </button>
                      </div>
                      <div className="flex items-center gap-4 mb-4">
                        <span className="px-4 py-1.5 bg-[#915726]/10 text-[#915726] text-sm font-semibold rounded-full">
                          {item.treatment}
                        </span>
                        <span className="px-4 py-1.5 bg-[#676028]/10 text-[#676028] text-sm font-semibold rounded-full">
                          {item.duration}
                        </span>
                      </div>
                      <p className="text-gray-600 leading-relaxed">{item.description}</p>
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
        )}

        {/* CTA */}
        <div className="text-center mt-20">
          <div className="inline-flex flex-col items-center bg-gradient-to-r from-[#915726]/5 via-[#915726]/10 to-[#915726]/5 rounded-3xl px-16 py-12 border border-[#915726]/10">
            <div className="w-16 h-16 flex items-center justify-center bg-[#915726] rounded-full mb-6">
              <i className="ri-magic-line text-2xl text-white"></i>
            </div>
            <h3
              className="text-3xl font-bold text-[#676028] mb-3"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Sua Transformação Começa Aqui
            </h3>
            <p className="text-gray-600 mb-8 max-w-md">
              Agende uma avaliação gratuita e descubra o tratamento ideal para você
            </p>
            <a
              href="#contato"
              onClick={(e) => {
                e.preventDefault();
                const el = document.getElementById('contato');
                if (el) {
                  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }}
              className="px-10 py-4 bg-[#915726] text-white text-lg font-medium rounded-full hover:bg-[#7A3010] transition-all duration-300 shadow-xl hover:shadow-[#915726]/40 hover:scale-105 whitespace-nowrap cursor-pointer"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Agende Sua Avaliação Gratuita
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
